import { render } from "./chatingCustomInfo.vue?vue&type=template&id=600203fd&scoped=true"
import script from "./chatingCustomInfo.vue?vue&type=script&lang=js"
export * from "./chatingCustomInfo.vue?vue&type=script&lang=js"

import "./chatingCustomInfo.vue?vue&type=style&index=0&id=600203fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600203fd"]])

export default __exports__